<form [formGroup]="insertionCyclesForm" *ngIf="!isLoading; else loadingAnimation">
    <app-alert *ngIf="!isSpi"
               [responsive]="true"
               type="warning"
               message="{{'admin.partNumbers.create-modal.pick-list.insertion-cycles.warning'| translate}}"></app-alert>
    <app-picklist
        *ngIf="partNumber"
        [disabled]="isReadOnly()"
        [source]="insertionCycles"
        [target]="partNumber.insertionCycles"
        formControlName="insertionCycles"
        [formControl]="insertionCyclesForm.controls['insertionCycles']"
        [dragDrop]="isSpi"
        [sourceHeader]="'admin.partNumbers.create-modal.pick-list.insertion-cycles.leftHeader' | translate"
        [targetHeader]="'admin.partNumbers.create-modal.pick-list.insertion-cycles.rightHeader' | translate">
    </app-picklist>
</form>
<ng-template #loadingAnimation>
    <app-loading-spinner class="loader"></app-loading-spinner>
</ng-template>
